import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

// SETUP COLORS
const GREY = {
  0: '#FFFFFF',
  100: '#F9FAFB',
  200: '#F4F6F8',
  300: '#DFE3E8',
  400: '#C4CDD5',
  500: '#919EAB',
  600: '#637381',
  700: '#454F5B',
  800: '#212B36',
  900: '#161C24',
};

const PRIMARY = {
  lighter: '#D1E9FC',
  light: '#76B0F1',
  main: '#2065D1',
  dark: '#103996',
  darker: '#061B64',
  contrastText: '#fff',
};

const SECONDARY = {
  lighter: '#fff',
  light: '#D6E4FF',
  main: '#3366FF',
  dark: '#1939B7',
  darker: '#091A7A',
  contrastText: '#fff',
};

const BLUE_SECONDARY = {
  lighter: '#fff',
  light: '#e3f2fd',
  main: '#2196f3',
  dark: '#1e88e5',
  darker: '#1976d2',
  contrastText: '#fff',
};

const GREY_SECONDARY = {
  lighter: '#fff',
  light: '#F9FAFB',
  main: '#C4CDD5',
  dark: '#919EAB',
  darker: '#637381',
  contrastText: '#fff',
};

const INFO = {
  lighter: '#fff',
  light: '#D0F2FF',
  main: '#1890FF',
  dark: '#0C53B7',
  darker: '#04297A',
  contrastText: '#fff',
};

const SUCCESS = {
  lighter: '#fff',
  light: '#e8f5e9',
  main: '#4caf50',
  dark: '#43a047',
  darker: '#2e7d32',
  contrastText: GREY[800],
};

const WARNING = {
  lighter: '#fff',
  light: '#fbe9e7',
  main: '#ff5722',
  dark: '#f4511e',
  darker: '#d84315',
  contrastText: GREY[800],
};

const ERROR = {
  lighter: '#fff',
  light: '#ffebee',
  main: '#e53935',
  dark: '#c62828',
  darker: '#b71c1c',
  contrastText: '#fff',
};

const palette = {
  common: { black: '#000', white: '#fff' },
  primary: PRIMARY,
  secondary: SECONDARY,
  grey_secondary: GREY_SECONDARY,
  blue_secondary: BLUE_SECONDARY,
  info: INFO,
  success: SUCCESS,
  warning: WARNING,
  error: ERROR,
  grey: GREY,
  divider: alpha(GREY[500], 0.24),
  text: {
    primary: GREY[800],
    secondary: GREY[600],
    disabled: GREY[500],
  },
  background: {
    paper: '#fff',
    default: GREY[100],
    neutral: GREY[200],
  },
  action: {
    active: GREY[600],
    hover: alpha(GREY[500], 0.08),
    selected: alpha(GREY[500], 0.16),
    disabled: alpha(GREY[500], 0.8),
    disabledBackground: alpha(GREY[500], 0.24),
    focus: alpha(GREY[500], 0.24),
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
};

export default palette;
